export class ExtraInfo {
  title = null;
  placeholders = [];
}
